import React from "react";
import localeText from "../../../../../../locale";

const TONES = {
  warning: { backgroundColor: "#FFF6E8", color: "#B76E00" },
  success: { backgroundColor: "#E7F8EE", color: "#178A4A" },
  neutral: { backgroundColor: "var(--theme-border, #EBEBEB)", color: "var(--theme-text, #262626)" },
};

const ExtrapayStatusBadge = ({ labelKey, tone = "warning" }) => (
  <span
    className="inline-flex px-2 py-1 border-round-md text-xs font-medium"
    style={TONES[tone] || TONES.neutral}
  >
    {localeText(labelKey)}
  </span>
);

export default ExtrapayStatusBadge;
